<script setup lang="ts">
import { InvoiceDetails } from '@/Pejer/types/invoice'
import { CircleCheckBig, ExternalLink } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'

defineProps<{
  invoiceDetails: InvoiceDetails
}>()
</script>

<template>
  <div class="flex flex-col gap-2 w-full items-center px-2">
    <CircleCheckBig class="w-20 h-20 text-green-500" stroke-width="1.5" />
    <h2 class="text-lg font-semibold">Faktura bekreftet!</h2>
    <div class="text-sm text-slate-500 w-full">
      <p>
        Fakturaen er sendt til: <strong>{{ invoiceDetails.invoice.customerEmail }}</strong
        >.
      </p>
      <p>Du kan også laste ned fakturaen nedenfor. Vennligst betal snarest.</p>
    </div>

    <div class="w-full max-w-md mt-2 bg-slate-50 p-4 rounded-lg shadow-sm">
      <h3 class="text-md font-semibold text-slate-700 mb-2">Fakturadetaljer</h3>
      <div class="text-sm text-slate-600">
        <p><strong>KID:</strong> {{ invoiceDetails.invoice.kid }}</p>
        <p><strong>Kontonummer (BBAN):</strong> {{ invoiceDetails.invoice.accountNumber }}</p>
        <p>
          <strong>Forfallsdato:</strong>
          {{
            invoiceDetails.invoice.dueDate
              ? new Date(invoiceDetails.invoice.dueDate).toLocaleDateString('nb-NO')
              : 'Snarest'
          }}
        </p>
        <p>
          <strong>Totalt beløp:</strong> kr
          {{ (invoiceDetails.invoice.grossAmount / 100).toFixed(2) }}
        </p>
      </div>
    </div>

    <div class="w-full flex flex-col md:flex-row gap-2 mt-2 items-center justify-center">
      <RouterLink
        :to="`/${invoiceDetails.paymentReferenceID}/invoice`"
        target="_blank"
        rel="noopener noreferrer"
        class="w-full"
      >
        <Button variant="secondary" class="w-full">
          Se faktura
          <ExternalLink class="w-4 h-4 ml-2" stroke-width="1.5" />
        </Button>
      </RouterLink>
      <!-- <a :href="successUrl" class="w-full">
        <Button variant="default" class="w-full group">
          Gå tilbake til nettsiden
          <ChevronRight class="w-4 h-4 group-hover:translate-x-1 transition-transform ml-1" />
        </Button>
      </a> -->
    </div>
  </div>
</template>
